module.exports = __webpack_public_path__ + "img/google-logo.686f8efa.svg";